import { render, staticRenderFns } from "./UserReportdetails.vue?vue&type=template&id=2432fe14"
import script from "./UserReportdetails.vue?vue&type=script&lang=js"
export * from "./UserReportdetails.vue?vue&type=script&lang=js"
import style0 from "./UserReportdetails.vue?vue&type=style&index=0&id=2432fe14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports